<template>
  <div>
    <v-list-item dense>
      <v-list-item-content>
        <p class="text-h6-nystext pt-2 pb-1">
          <span class="text-h6-nystext-regular" v-if="this.$store.getters.getActiveDistrictType === 'cd'">
            Congressional Districts
          </span>
          <span class="text-h6-nystext-regular" v-else-if="this.$store.getters.getActiveDistrictType === 'sd'">
            State Legislative Districts (Upper)
          </span>
          <span class="text-h6-nystext-regular" v-else-if="this.$store.getters.getActiveDistrictType === 'ad'">
            State Legislative Districts (Lower)
          </span>
          <!--   <span v-bind:style="{ color: sideColor }" class="text-uppercase">
            {{ title }}
          </span> -->
          <br />
          <!--           <span class="text-h6-nystext-regular">
            <span class="text-h6-nystext-regular">
              {{ this.stateWideDistrictTypeData.displayname || "" }}
            </span>
          </span> -->
        </p>
        <p class="text-body-2 mb-0 select-plan" v-show="side === 'A'"><em>Select a district plan below to <b>compare
              with a plan from the list on the RIGHT</b>:</em></p>
        <p class="text-body-2 mb-0 select-plan" v-show="side === 'B'"><em>Select a district plan below to <b>compare
              with a plan from the list on the LEFT</b>:</em></p>
        <StateSearch :isFinal="isFinal" :side="side" />
        <ProposalSelectionDropdown :proposals="proposalsForSelection" :side="side" />
        <DistrictSearch :isFinal="isFinal" :side="side" />
      </v-list-item-content>
    </v-list-item>
  </div>
</template>
<script>
import { getProposalsForSelection } from "../../js/ProposalSelection";
import DistrictSearch from "./DistrictSearch.vue";
import ProposalSelectionDropdown from "./ProposalSelectionDropdown.vue";
import StateSearch from "./StateSearch.vue";

export default {
  name: "SideHeader",
  props: ["side", "sideColor", "stateWideDistrictTypeData", "isFinal"],
  components: {
    DistrictSearch,
    ProposalSelectionDropdown,
    StateSearch
  },
  data: function () {
    return {};
  },
  mounted: function () { },
  methods: {},
  watch: {},
  computed: {
    proposalsForSelection() {
      const activeDistrictType = this.$store.getters.getActiveDistrictType
      const selectedState = this.$stateData.states.find(
        (state) => state.statefips === this.$store.getters.getSelectedState
      )
      const stateAbb = selectedState?.stateabb?.toLowerCase() ?? null

      return getProposalsForSelection(this.$pgConfig, activeDistrictType, stateAbb)
    },
    showProposalDropDown: function () {
      // only show the proposal dropdown if state is set to is congress, state that has an active proposal, and it is side B
      const activeStateProp = this.proposalsForSelection?.filter(d => d.state && d.active === 'TRUE')
      return this.$store.getters.getActiveDistrictType === 'cd' && activeStateProp.length
    },
    title: function () {
      // get display name
      return this.$store.getters[`getSide${this.side}DisplayName`]
    }
  },
};
</script>
<style></style>
